<template>
  <div class="mystudio container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Manage App</h4>
              </div>
            </div>
          </div>
          <b-card class="p-3">
            <p class="manage-app-mid-p my-0">
              Here are a few things to help you manage your app.
            </p>

            <b-card
              title="Splash Sreens"
              tag="article"
              class="card-transparent-background mid-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Manage the app’s splash screens
              </b-card-text>
              <router-link
                to="/my_irish_date/splash_screens"
                class="card-link irishDateLink"
              >
                Change Images
                <span class="mx-1 my-auto">
                  <font-awesome-icon
                    icon="fa-solid fa-arrow-right"
                    size="md"
                    class="align-middle"
                  />
                </span>
              </router-link>
            </b-card>
            <b-card
              title="Choose your interests and Describe yourself"
              tag="article"
              class="card-transparent-background mid-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Change or add interests \ Change Words to describe yourself
              </b-card-text>

              <router-link
                to="/my_irish_date/interests"
                class="card-link irishDateLink d-flex"
              >
                Go to lists
                <span class="mx-1 my-auto">
                  <font-awesome-icon
                    icon="fa-solid fa-arrow-right"
                    size="md"
                    class="align-middle"
                  />
                </span>
              </router-link>
            </b-card>
            <b-card
              title="Questionnaire"
              tag="article"
              class="card-transparent-background mid-border-div mb-2"
            >
              <b-card-text class="mb-2">
               Manage Questions and Responds
              </b-card-text>

              <router-link
                to="/my_irish_date/questionnaire"
                class="card-link irishDateLink"
              >
               Go To questionnaire
                <span class="mx-1 my-auto">
                  <font-awesome-icon
                    icon="fa-solid fa-arrow-right"
                    size="md"
                    class="align-middle"
                  />
                </span>
              </router-link>
            </b-card>
            <b-card
              title="Manage Packs"
              tag="article"
              class="card-transparent-background mid-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Manage Subscriptions and Premium Packs
              </b-card-text>

              <router-link
                to="/my_irish_date/subscriptions_packs"
                class="card-link irishDateLink"
              >
                Go To Packs
                <span class="mx-1 my-auto">
                  <font-awesome-icon
                    icon="fa-solid fa-arrow-right"
                    size="md"
                    class="align-middle"
                  />
                </span>
              </router-link>
            </b-card>
            <b-card
              title="Manage Guidelines"
              tag="article"
              class="card-transparent-background mid-border-div mb-2"
            >
              <b-card-text class="mb-2">
               Set Terms and Conditions \ Privacy Policy
              </b-card-text>

              <router-link
                to="/my_irish_date/manage_guidelines"
                class="card-link irishDateLink"
              >
               Edit Guidelines
                <span class="mx-1 my-auto">
                  <font-awesome-icon
                    icon="fa-solid fa-arrow-right"
                    size="md"
                    class="align-middle"
                  />
                </span>
              </router-link>
            </b-card>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MIDManageApp",
  components: {},
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/ManageApp.vue